module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src023959432/src/github.com/GipsyBot/gipsy-webapp/node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = 512
// module chunks = 0